







// import * as Chartjs from "chart.js"
import { Chart } from "chart.js"
import Papa from "papaparse"
import Vue from "vue"
import { SalesChart } from "../saleschart"
import { Common } from "./../../common/common"
// import * as logger from "morgan"

/** 外部公開用 親から呼び出すことを想定 */
export interface PromptMethods {
  /** ダイアログ表示 */
  show: () => void
}

export default Vue.extend({
  props: {
    data: String,
    type: Number,
  },
  data() {
    return {
      //
    }
  },
  /** Vue構築完了時の処理 */
  created: function init() {
    this.$nextTick(() => {

      const ctx = (document.getElementById(this.data) as HTMLCanvasElement).getContext("2d")!
      // vh vw で指定するのもアリかもしれない
      // ctx.canvas.height = 280

      switch (this.type) {
        case 0: // 売上トップ
          SalesChart.hotSale(ctx)
          break
        case 1: // 顧客別売上構成
          SalesChart.salesRateByCustomer(ctx)
          break
        case 2: // 時期別売上
          // SalesChart.salesByPeriod(ctx)
          break
        case 3: // 商品売上推移
          // SalesChart.salesRateByCustomer(ctx)
          break
        case 4: // 取引先別売上推移
          SalesChart.salesTrendsByCustomer(ctx)
          break
        case 5: // 需要予測
          // setTimeout(() => {
          //   SalesChart.chartdemand(ctx)
          // }, 1000)
          break
        case 6: // 売上実績
          setTimeout(() => {
            SalesChart.salesPeformance(ctx)
          }, 1000)
          break

        default:
          break
      }
      // if (this.type === 0) {
      //   SalesChart.hotSale(ctx)
      // } else {
      //   const mixedChart = new Chart(ctx, {
      //     type: "bar",
      //     data: {
      //       datasets: [{
      //         label: "単月売上",
      //         data: [10, 20, 15, 30],
      //         backgroundColor: "rgba(255, 99, 132, 0.2)",

      //       }, {
      //         label: "合計",
      //         data: [10, 30, 45, 75],
      //         backgroundColor: "rgba(54, 162, 235, 0.2)",


      //         // このデータセットを線グラフにする
      //         type: "line",
      //       }],
      //       labels: ["1月", "2月", "3月", "4月"],
      //     },
      //     options: {
      //       scales: {
      //         yAxes: [{
      //           ticks: {
      //             beginAtZero: true,
      //           },
      //         }],
      //       },
      //     },
      //   })

      // }


    })
  },
  methods: {
    //
  },
})
